import { render, staticRenderFns } from "./transportCapabilityDialog.vue?vue&type=template&id=4e2b62e8&scoped=true"
import script from "./transportCapabilityDialog.vue?vue&type=script&lang=js"
export * from "./transportCapabilityDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2b62e8",
  null
  
)

export default component.exports